module.exports = __webpack_public_path__ + "static/media/fansfirst-logo-small.fb26bee2.svg";